module.exports = __webpack_public_path__ + "static/media/ribeirao-background.2cc49551.png";